import { ErrorBoundary } from 'react-error-boundary';
import { DefaultErrorHandler } from './DefaultErrorHandler';

interface Props {
    showError?: boolean;
}

export const DefaultErrorBoundary = ({ showError = true, children }: React.PropsWithChildren<Props>) => (
    <ErrorBoundary fallbackRender={() => (showError ? <DefaultErrorHandler /> : children)}>{children}</ErrorBoundary>
);
